import React from 'react';
import { Box, Text, Link, HStack, Container } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box as="footer" bg="gray.100" py={6} mt={10}>
      <Container maxW="1200px">
        <HStack justify="space-between" wrap="wrap">
          <Text color="gray.600">
            &copy; {new Date().getFullYear()} NIH Termination Tracker
          </Text>
          <HStack spacing={4}>
            <Link as={RouterLink} to="/privacy" color="gray.600">
              Privacy Policy
            </Link>
            <Link as={RouterLink} to="/contact" color="gray.600">
              Contact Us
            </Link>
          </HStack>
        </HStack>
      </Container>
    </Box>
  );
};

export default Footer;